var React = require('react');

function Analytics (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4 3a1 1 0 0 1 1 1v21a1 1 0 0 0 1 1h22a1 1 0 1 1 0 2H5a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1zm23.636 4.228a1 1 0 0 1 .136 1.408l-7.563 9.183-5.495-3.497-5.938 7.309a1 1 0 1 1-1.552-1.262l7.062-8.69 5.505 3.502 6.437-7.817a1 1 0 0 1 1.408-.136z","fill":"#fff"}));
}

Analytics.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Analytics;

Analytics.default = Analytics;
